import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './gallery.css'

const Gallery = (props) => {
  return (
    <div
      id={props.galleryId}
      className={`gallery-thq-gallery3-elm thq-section-padding scroll-target ${props.rootClassName} `}
    >
      <div className="gallery-thq-max-width-elm thq-section-max-width">
        <div className="gallery-thq-section-title-elm">
          <h2 className="gallery-thq-text-elm1 thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="gallery-text1">Gallery</span>
              </Fragment>
            )}
          </h2>
          <span className="gallery-thq-text-elm2 thq-body-large">
            {props.content1 ?? (
              <Fragment>
                <span className="gallery-text2">
                  Browse through our gallery to see our team in action and the
                  vehicles we have assisted.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="gallery-container1">
          <div className="gallery-thq-content-elm">
            <div
              data-thq="slider"
              data-loop="true"
              data-autoplay="false"
              data-navigation="true"
              data-pagination="false"
              data-disable-autoplay-on-interaction="false"
              className="gallery-thq-slider-elm swiper"
            >
              <div
                data-thq="slider-wrapper"
                className="gallery-thq-slider-wrapper-elm swiper-wrapper"
              >
                <div
                  data-thq="slider-slide"
                  className="gallery-thq-slider-slide-elm1 swiper-slide"
                >
                  <div className="gallery-container2">
                    <img
                      alt={props.image1Alt}
                      src={props.image1Src}
                      className="gallery-thq-image1-elm thq-img-ratio-4-3"
                    />
                  </div>
                  <div className="gallery-container3">
                    <img
                      alt={props.image2Alt}
                      src={props.image2Src}
                      className="gallery-thq-image2-elm thq-img-ratio-4-3"
                    />
                  </div>
                </div>
                <div
                  data-thq="slider-slide"
                  className="gallery-thq-slider-slide-elm2 swiper-slide"
                >
                  <div className="gallery-container4">
                    <img
                      alt={props.image3Alt}
                      src={props.image3Src}
                      className="gallery-thq-image3-elm thq-img-ratio-4-3"
                    />
                  </div>
                  <div className="gallery-container5">
                    <img
                      alt={props.image4Alt}
                      src={props.image4Src}
                      className="gallery-thq-image4-elm thq-img-ratio-4-3"
                    />
                  </div>
                </div>
                <div
                  data-thq="slider-slide"
                  className="gallery-thq-slider-slide-elm3 swiper-slide"
                >
                  <div className="gallery-container6">
                    <img
                      alt={props.image5Alt}
                      src={props.image5Src}
                      className="gallery-thq-image5-elm thq-img-ratio-4-3"
                    />
                  </div>
                  <div className="gallery-container7">
                    <img
                      alt={props.image6Alt}
                      src={props.image6Src}
                      className="gallery-thq-image6-elm thq-img-ratio-4-3"
                    />
                  </div>
                </div>
              </div>
              <div
                data-thq="slider-button-prev"
                className="gallery-thq-slider-button-prev-elm swiper-button-prev"
              ></div>
              <div
                data-thq="slider-button-next"
                className="gallery-thq-slider-button-next-elm swiper-button-next"
              ></div>
              <div
                data-thq="slider-pagination"
                className="gallery-thq-slider-pagination-elm swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal"
              >
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet swiper-pagination-bullet-active"
                ></div>
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet"
                ></div>
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Gallery.defaultProps = {
  image5Alt: 'Emergency towing service',
  image1Alt: 'Towing a car',
  image3Src:
    'https://images.unsplash.com/photo-1513569026477-146b9135d2ee?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzUxNjA0OHw&ixlib=rb-4.1.0&q=80&w=1400',
  heading1: undefined,
  galleryId: '',
  image1Src:
    'https://images.unsplash.com/photo-1694719153837-9b488915fa37?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzUxNjA0OHw&ixlib=rb-4.1.0&q=80&w=1400',
  image2Alt: 'Towing a truck',
  image4Alt: 'Evac team at work',
  rootClassName: '',
  image3Alt: 'Towing a motorcycle',
  image4Src:
    'https://images.unsplash.com/photo-1595432914032-9a17e9a60458?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzUxNjA0N3w&ixlib=rb-4.1.0&q=80&w=1400',
  content1: undefined,
  image2Src:
    'https://images.unsplash.com/photo-1677790931170-90cbb761f335?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzUxNjA0N3w&ixlib=rb-4.1.0&q=80&w=1400',
  image5Src:
    'https://images.unsplash.com/photo-1590135317569-fa89511cb6e8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzUxNjA0N3w&ixlib=rb-4.1.0&q=80&w=1400',
  image6Alt: 'Customer testimonial with towed vehicle',
  image6Src:
    'https://images.unsplash.com/photo-1532019831386-8df1917e15d0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzUxNjA0N3w&ixlib=rb-4.1.0&q=80&w=1400',
}

Gallery.propTypes = {
  image5Alt: PropTypes.string,
  image1Alt: PropTypes.string,
  image3Src: PropTypes.string,
  heading1: PropTypes.element,
  galleryId: PropTypes.string,
  image1Src: PropTypes.string,
  image2Alt: PropTypes.string,
  image4Alt: PropTypes.string,
  rootClassName: PropTypes.string,
  image3Alt: PropTypes.string,
  image4Src: PropTypes.string,
  content1: PropTypes.element,
  image2Src: PropTypes.string,
  image5Src: PropTypes.string,
  image6Alt: PropTypes.string,
  image6Src: PropTypes.string,
}

export default Gallery
